module.exports = "<input type=\"text\" placeholder=\"{{item_placeholder}}\" class=\"list_item_text {{item_title}}\">";